// 택배 API 문서 데이터 (v1.1)
import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc, apiMatrixTable } from '../docHelpers';

/**
 * 쇼핑몰연동 운송장출력의 작업결과 수신 데이터(`msg`) 파싱 예시.
 *
 * `msg` 는 JSON 문자열이라 `callback_example` 에 담으면 한 줄로 길게 이어져 구조가 읽히지 않는다.
 * 파싱한 뒤의 모양은 Description 에 코드 블록으로 둔다.
 */
const CALLBACK_MSG_PARSED_EXAMPLE = `{
  "body": {
    "work_no": 1377010000,
    "job_name": "운송장번호 발급",
    "status": "완료",
    "message": "[성공] : 4016199096202570 : 편의점택배 | SL0123456789 | https://cdn.shopline.com/labels/SL0123456789.pdf, [실패] : 4022653907792113 : 연동 물류사 외부 실행에 실패했습니다.",
    "shop_cd": "X091",
    "shop_id": "playauto@cowave.kr",
    "site_name": "샵라인몰1.0",
    "site_nick": "샵라인테스트"
  },
  "header": {
    "bizPtrId": "PLAYAUTO",
    "callId": "playauto0001",
    "ifCd": "PLAYAUTO",
    "encType": "UTF-8",
    "token": "YOUR_TOKEN"
  }
}`;

const getV11APIs = (userInfo) => {
  return [
    {
      title: '쇼핑몰연동 운송장출력',
      url: '/doc/쇼핑몰연동 운송장출력',
      data: [
        {
          authorized_aff_no: [1051],
          version: 'v1.1',
          url: '/work/addWorkSelect/v1.1',
          method: 'POST',
          desc: (
            <>
              {apiDocDesc({
                intro:
                  '쇼핑몰이 자체 제공하는 연동 물류(편의점택배 등)로 출고를 실행하고 운송장번호와 라벨을 발급받습니다.',
                items: [
                  '작업을 등록하고 작업번호(work_no)를 즉시 반환합니다.<br />발행 결과는 <code>api_callback_url</code> 로 POST 방식으로 전송합니다.',
                  {
                    text: '현재 샵라인몰1.0(<code>X091</code>) 편의점택배만 지원합니다.',
                    sub: '그 외 쇼핑몰의 주문을 요청하면 작업이 <code>쇼핑몰 연동 택배사가 없습니다.</code> 사유로 실패합니다.',
                  },
                  {
                    text: '발행은 묶음 단위로 처리됩니다.',
                    sub: '<code>list</code> 에 묶음번호(<code>bundle_no</code>)를 입력해주세요.<br />해당 묶음에 속한 모든 주문이 대상이 되며 결과도 묶음 단위로 전달됩니다.',
                  },
                  {
                    text: '작업 상태(<code>status</code>)가 <code>완료</code> 라도 전건 성공을 의미하지 않습니다.',
                    sub: '묶음 중 하나라도 발번에 성공하면 <code>완료</code> 로 전달됩니다.<br />묶음별 성공·실패는 <code>message</code> 를 확인해주세요.',
                  },
                  {
                    text: '운송장번호는 발급되고 라벨 발급만 실패한 경우도 성공으로 집계됩니다.',
                    sub: '이 경우 라벨 URL 자리에 실패 사유가 담깁니다.<br />같은 묶음번호로 재요청하면 출고 실행(부킹)을 다시 하지 않고 라벨만 재발급합니다.',
                  },
                  {
                    text: '이미 운송장이 발행된 묶음이 포함되어 있으면 작업 등록이 거부됩니다.',
                    sub: '<code>e2007</code> 로 리턴되며 해당 묶음번호가 함께 전달됩니다.<br />샵라인몰1.0 편의점택배는 라벨 재출력을 위해 예외로 허용됩니다.',
                  },
                  '쇼핑몰 계정이 여러 개이거나 묶음이 400건을 초과하면 작업이 분할 등록되어 작업번호가 여러 개 전달됩니다.',
                  '실제 물류사 부킹이 발생하는 작업입니다. 테스트 목적으로 반복 호출하지 않도록 주의해주세요.',
                ],
                notes: [
                  '작업결과와 수신 데이터(<code>api_callback_url</code>)의 응답 포맷은 쇼핑몰 작업의 작업결과 응답 포맷을 따릅니다.<br />',
                ],
              })}
              {apiMatrixTable({
                intro:
                  '<br /><strong>작업결과 수신 데이터 형식</strong><br />결과는 <code>application/x-www-form-urlencoded;charset=UTF-8</code> 로 전송되며, 작업 결과는 <code>msg</code> 에 JSON 문자열로 담깁니다.',
                headers: ['필드', '타입', '설명'],
                rows: [
                  ['<code>com</code>', 'String', '전송 주체<br /><code>PLAYAUTO</code> 로 고정 전달됩니다.'],
                  ['<code>encver</code>', 'String', '전문 버전<br /><code>2.0</code> 으로 고정 전달됩니다.'],
                  ['<code>encYn</code>', 'String', '암호화 여부<br /><code>N</code> 으로 고정 전달됩니다.'],
                  [
                    '<code>msg</code>',
                    'String',
                    '작업 결과<br />JSON 문자열이므로 파싱 후 <code>body</code>·<code>header</code> 로 사용해주세요.',
                  ],
                  ['<code>msg.body.work_no</code>', 'Number', '작업번호'],
                  [
                    '<code>msg.body.job_name</code>',
                    'String',
                    '작업명<br /><code>운송장번호 발급</code> 으로 전달됩니다.',
                  ],
                  [
                    '<code>msg.body.status</code>',
                    'String',
                    '작업 상태<br /><code>완료</code> / <code>실패</code><br />발번에 성공한 묶음이 1건 이상이면 <code>완료</code>, 0건이면 <code>실패</code> 입니다.',
                  ],
                  [
                    '<code>msg.body.message</code>',
                    'String',
                    '묶음별 결과 문구<br />여러 묶음의 결과가 <code>, </code> 로 이어붙여 전달됩니다.<br />형식: <code>[성공|실패] : {묶음번호} : {택배사명} | {운송장번호} | {라벨URL 또는 라벨 실패사유}</code><br />실패한 묶음은 택배사명 뒤 항목 없이 실패 사유만 전달됩니다.',
                  ],
                  [
                    '<code>msg.body.shop_cd</code>',
                    'String',
                    '쇼핑몰 코드<br /><code>show_shop_info_yn</code> 을 <code>true</code> 로 요청한 경우에만 포함됩니다.',
                  ],
                  [
                    '<code>msg.body.shop_id</code>',
                    'String',
                    '쇼핑몰 계정 아이디<br /><code>show_shop_info_yn</code> 을 <code>true</code> 로 요청한 경우에만 포함됩니다.',
                  ],
                  [
                    '<code>msg.body.site_name</code>',
                    'String',
                    '쇼핑몰명<br /><code>show_shop_info_yn</code> 을 <code>true</code> 로 요청한 경우에만 포함됩니다.',
                  ],
                  [
                    '<code>msg.body.site_nick</code>',
                    'String',
                    '쇼핑몰 별칭<br /><code>show_shop_info_yn</code> 을 <code>true</code> 로 요청한 경우에만 포함됩니다.',
                  ],
                  [
                    '<code>msg.header.token</code>',
                    'String',
                    '인증 토큰<br /><code>api_callback_url</code> 의 <code>?token=</code> 뒷값이 그대로 전달됩니다.<br />수신 URL 은 <code>?</code> 앞부분만 사용합니다.',
                  ],
                  [
                    '<code>msg.header.bizPtrId</code>',
                    'String',
                    '<code>PLAYAUTO</code> 로 고정 전달됩니다.',
                  ],
                  [
                    '<code>msg.header.callId</code>',
                    'String',
                    '<code>playauto0001</code> 로 고정 전달됩니다.',
                  ],
                  ['<code>msg.header.ifCd</code>', 'String', '<code>PLAYAUTO</code> 로 고정 전달됩니다.'],
                  ['<code>msg.header.encType</code>', 'String', '<code>UTF-8</code> 로 고정 전달됩니다.'],
                ],
              })}
              <div className='description'>수신 데이터(msg) 파싱 예시</div>
              <pre className='prettyprint'>{CALLBACK_MSG_PARSED_EXAMPLE}</pre>
            </>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'work_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '작업액션',
                sub: '쇼핑몰연동 운송장출력 작업 고정값입니다.',
                allowedValues: ['ISSUE_INVOICE_PLATFORM'],
              }),
            },
            {
              title: 'list',
              required: 'O',
              type: 'String[]',
              desc: apiParamDesc({
                title: '묶음번호',
                sub: 'bundle_no 를 배열로 입력해주세요.<br />묶음에 속한 모든 주문이 대상이 됩니다.',
              }),
            },
            {
              title: 'api_callback_url',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '작업완료시 작업결과를 수신받을 URL',
                sub: '해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로 전송합니다.<br /><code>?token=</code> 을 붙여 입력하시면 앞부분을 수신 URL 로, 뒷값을 인증 토큰으로 사용합니다.',
                notes: [
                  '미입력시 작업결과가 전송되지 않으므로 작업결과 조회 API 로 확인해주세요.',
                ],
              }),
            },
            {
              title: 'show_shop_info_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '작업결과에 쇼핑몰정보 노출여부',
                sub: 'true 인 경우 수신 데이터에 쇼핑몰 코드·계정 아이디·쇼핑몰명·별칭이 포함됩니다.',
                defaultValue: 'false',
              }),
            },
          ],
          body_example: {
            work_type: 'ISSUE_INVOICE_PLATFORM',
            list: ['4016199096202570', '4022653907792113'],
            api_callback_url: 'https://test.io/callback',
            show_shop_info_yn: true,
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: apiParamDesc({
                title: '작업 등록 결과',
                sub: '작업 등록 성공 여부이며 운송장 발행 성공을 의미하지 않습니다.<br />(실패시 <code>error</code> 로 출력)',
              }),
            },
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 작업번호',
              indent: 1,
            },
            {
              title: 'error_code',
              required: '',
              type: 'String',
              desc: '실패시 출력되는 에러코드',
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '성공, 실패 메세지',
              indent: 1,
            },
            {
              title: 'list',
              required: '',
              type: 'String[]',
              desc: '등록한 list 정보\n(성공인경우 출력)',
              indent: 1,
            },
          ],
          response_example: {
            results: [
              {
                work_no: 487772398,
                message: '작업이 정상적으로 등록되었습니다.',
                list: ['4016199096202570', '4022653907792113'],
              },
            ],
          },
          error_example: {
            error: [
              {
                work_no: 0,
                error_code: 'e2007',
                message: '배송정보가 이미 입력된 주문건이 존재합니다. (4016199096202570)',
              },
            ],
          },
          // api_callback_url 설정시 수신되는 데이터. msg 파싱 후의 모양은 Description 참고
          callback_example: {
            com: 'PLAYAUTO',
            encver: '2.0',
            encYn: 'N',
            msg: '{"body":{"work_no":1377010000,"job_name":"운송장번호 발급","status":"완료","message":"[성공] : 4016199096202570 : 편의점택배 | SL0123456789 | https://cdn.shopline.com/labels/SL0123456789.pdf, [실패] : 4022653907792113 : 연동 물류사 외부 실행에 실패했습니다.","shop_cd":"X091","shop_id":"playauto@cowave.kr","site_name":"샵라인몰1.0","site_nick":"샵라인테스트"},"header":{"bizPtrId":"PLAYAUTO","callId":"playauto0001","ifCd":"PLAYAUTO","encType":"UTF-8","token":"YOUR_TOKEN"}}',
          },
        },
      ],
    },
  ];
};

export default getV11APIs;
